import {
  IcommLimits,
  IftPayoutBankDetails,
} from "../../../../types/components/fundTransfer/ftTypes";
import React from "react";
import { FtInpField } from "../../generic/ftInpField";
import TocDropdown from "../../../../generic/tocDropdown";
import FtConfirmBtn from "../../ftConfirmBtn";
import {
  AFtWidthrawFundEq,
  AFtWidthrawFundComm,
} from "../../../../service/fundTransfer/fundTransferApiService";
import { parsedToken } from "../../../../service/storageHelper";
import { useHistory } from "react-router-dom";
import indexer, { IListObj } from "../../../../types/genericTypes";
import { IPayOut } from "../../ftInterfaces";
import { ftHelpDetails, FTRegex } from "../../ftConstants";
import { Idevice } from "../../../../types/device";
import DeviceContext from "../../../../service/indentifyDevice";

export interface FtPayoutFormContProps {
  bnkAcs: Array<any>;
  asset: string;
  eqCash: string;
  coCash: IcommLimits;
}

const FtPayoutFormCont: React.FC<FtPayoutFormContProps> = (props) => {
  const pToken = parsedToken();
  let history = useHistory();

  //type of device tablet/mobile/desktop
  const handleDevice: Idevice = DeviceContext();
  // list of banks linked to the trading account
  const banksList: Array<IListObj> = props.bnkAcs.map(
    (d: IftPayoutBankDetails, index: number) => ({
      value: index,
      display:
        props.asset === "EQ"
          ? d.bankName + " - " + d.bankAccountNo
          : d.bnkName + " - " + d.bnkAccNo,
    })
  );

  const [userInput, setUserInput] = React.useState<{
    amount: string;
    bank: IftPayoutBankDetails | null;
    remarks: string;
  }>({
    amount: "",
    bank: props.bnkAcs.length > 0 ? props.bnkAcs[0] : null,
    remarks: "",
  });

  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);

  const [textAreaFocusClass, setTextAreaFocusClass] = React.useState("");

  const [submitErr, setSubmitErr] = React.useState<{
    errMsg: string;
    errCd: string;
    actCd: string;
  }>({ errMsg: "", errCd: "", actCd: "" });

  //error messages associated with input field amt
  let ftAmtErrMsgs: indexer = {
    min: "Please enter valid amount",
    max: "Amount entered exceeds your available balance.",
    required: "",
  };

  //message dispatcher to show error messages
  const [message] = React.useState<Array<string>>([ftAmtErrMsgs["required"]]);

  function onAmountChange(key: string, value: any) {
    setUserInput({ ...userInput, [key]: value });
  }

  /**
   * Checks for all the validations and then changes value accordingly
   * @param e The input event
   */
  function onRemarkChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (e.target.value.length <= 140) {
      setUserInput({ ...userInput, remarks: e.target.value });
    }
  }

  function ftWithdrawFundRes(res: any) {
    setSubmitErr({ errCd: "", errMsg: "", actCd: "" });

    if (res.data ? res.data.sts === "true" : res.data) {
      if (userInput.bank) {
        const url =
          "/fund-transfer/withdraw-funds/status?status=" +
          JSON.stringify({
            seg: "",
            bnkName:
              props.asset === "EQ"
                ? userInput.bank.bankName
                : userInput.bank.bnkName,
            bnkAccNo:
              props.asset === "EQ"
                ? userInput.bank.bankAccountNo
                : userInput.bank.bnkAccNo,
            brcName:
              props.asset === "EQ"
                ? userInput.bank.bankBranchName
                : userInput.bank.brcName,
            ifsc: userInput.bank.ifsc,
            trnsAmt: userInput.amount.toString(),
            rmk: userInput.remarks.toString(),
            accType: props.asset,
          });

        history.push(url);
      }
    } else if (res.error) {
      setSubmitErr(res.error);
      setIsFormSubmitted(false);
    }
  }

  function submitForm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    setIsFormSubmitted(true);
    setSubmitErr({ errCd: "", errMsg: "", actCd: "" });

    if (userInput.bank) {
      const data: IPayOut = {
        seg: "",
        bnkName:
          props.asset === "EQ"
            ? userInput.bank.bankName
            : userInput.bank.bnkName,
        bnkAccNo:
          props.asset === "EQ"
            ? userInput.bank.bankAccountNo
            : userInput.bank.bnkAccNo,
        brcName:
          props.asset === "EQ"
            ? userInput.bank.bankBranchName
            : userInput.bank.brcName,
        ifsc: userInput.bank.ifsc,
        trnsAmt: userInput.amount.toString(),
        rmk: userInput.remarks.toString(),
      };

      if (
        pToken &&
        (pToken.accType === "EQ" ||
          (pToken.accType === "COMEQ" && props.asset === "EQ"))
      ) {
        AFtWidthrawFundEq(ftWithdrawFundRes, data);
      } else if (
        pToken &&
        (pToken.accType === "CO" ||
          (pToken.accType === "COMEQ" && props.asset === "CO"))
      ) {
        AFtWidthrawFundComm(ftWithdrawFundRes, data);
      }
    }
  }
  React.useEffect(() => {
    setUserInput({ ...userInput, bank: props.bnkAcs[0] });
  }, [props.bnkAcs]);
  return (
    <div className="eq_form_fld">
      <div className="form-field">
        <FtInpField
          value={userInput.amount}
          clsNm="ft_payin_input"
          max={+(props.eqCash || props.coCash.lmAvl)}
          min={1}
          autoFocus={true}
          type={!handleDevice.isMobile ? "text" : "number"}
          showProxyField={true}
          vr="normal"
          ph="Eg: 10,000"
          name="amount"
          pattern={FTRegex.mobAmt}
          regEx={FTRegex.amt}
          validation={{
            max: +(props.eqCash || props.coCash.lmAvl),
            required: true,
            min: 1,
          }}
          label="Enter Amount"
          error={ftAmtErrMsgs}
          info={message[0]}
          prefix="&#8377;"
          proxy_inp="proxy"
          validateOnChange={true}
          onChange={onAmountChange}
          maxlength={10}
        />
      </div>
      <div className="form-field">
        <label className="input-label">Select Bank</label>
        <TocDropdown
          selectedValue={
            userInput.bank ? props.bnkAcs.indexOf(userInput.bank) : 0
          }
          dropdownOptions={banksList ? banksList : []}
          onSelect={(value) =>
            setUserInput({
              ...userInput,
              bank: props.bnkAcs[value as number],
            })
          }
          isSearchable={false}
        />
      </div>

      <div className="form-field tArea">
        <label className="input-label vTop pd-t15">Enter Remarks</label>
        <div className={"ft_input_field_cont vTop" + textAreaFocusClass}>
          <textarea
            value={userInput.remarks}
            onChange={onRemarkChange}
            placeholder="Eg: Toward's clear balance"
            className={"text_field " + (userInput.remarks ? " filled" : "")}
            onFocus={() => setTextAreaFocusClass(" focus")}
            onBlur={() => setTextAreaFocusClass("")}
          />
          <div className="text_prefix ">
            {(userInput.remarks as string).length} / 140
          </div>
        </div>
      </div>
      {submitErr.errMsg && (
        <div className="formInpCont dBlock mg--t30 mg-b30">
          <p className={`info taCenter`} data-error={true}>
            {submitErr.errMsg}
          </p>
        </div>
      )}
      <div className="confirm_btn_wrap">
        <FtConfirmBtn
          onClick={submitForm}
          errTxt={""}
          disbaled={
            isFormSubmitted ||
            !+userInput.amount ||
            (+userInput.amount > +props.eqCash && props.asset === "EQ") ||
            (+userInput.amount > +props.coCash.lmAvl && props.asset === "CO")
          }
        />
      </div>
      <div className="info_erap">
        <p>
          In case the bank account mentioned is incorrect; you are requested to
          contact customer service. Write to{" "}
          <a href={"mailto:" + ftHelpDetails.email}>{ftHelpDetails.email}</a>
        </p>
      </div>
    </div>
  );
};

export default FtPayoutFormCont;
